import { BrieAITool } from "../../../types/BrieInterfaces";
import classNames from "classnames";
import DropdownMenuDivider from "../../../components/Menus/DropdownMenuDivider";
import { Card } from "reactstrap";
import { useNavigate, useParams } from "react-router-dom";

interface Props {
  open: boolean;
  setOpen: (open: boolean) => void;
  AITools: BrieAITool[];
}

const BrieMobileSidebar = ({ open, setOpen, AITools }: Props) => {
  const navigate = useNavigate();
  const { tenantID, tab } = useParams();
  const handleSetActiveTool = (tool: string) => {
    setOpen(false);
    navigate(`/clouds/${tenantID}/brie/${tool}`);
  };

  const openAITools = AITools.filter((aiTool) => aiTool.powered === "open-ai");
  const brieAITools = AITools.filter((aiTool) => aiTool.powered === "brie");

  return (
    <>
      <div
        className={classNames("d-flex justify-content-center")}
        style={{
          height: "36px",
          width: open ? "100%" : "38px",
          boxShadow: "0px 1px 8px 2px rgba(0, 0, 0, 0.15)",
          backgroundColor: "#F2F6F4",
        }}
        onClick={() => setOpen(!open)}
      >
        <i
          className={classNames(
            `mdi mdi-chevron-${open ? "left" : "right"} cursor-pointer`
          )}
          style={{
            fontSize: "24px",
            marginLeft: open ? "auto" : "2px",
            marginRight: open ? "10px" : "0px",
          }}
        />
      </div>
      {open && (
        <div
          className="d-flex flex-column align-items-center"
          style={{
            height: "calc(100vh - 100px)",
            width: "100%",
            overflowY: "auto",
            overflowX: "hidden",
            backgroundColor: "#f9fbfa",
            borderRight: "1px solid #e8edea",
            borderBottom: "1px solid #e8edea",
            zIndex: 2,
            top: "50px",
            boxShadow: open
              ? "inset -4px 0px 3px -4px rgba(0, 0, 0, 0.1)"
              : "none",
          }}
        >
          <Card
            className={classNames("d-flex flex-column btn-oauth", {
              "justify-content-start m-2 p-2": open,
              "justify-content-center m-1": !open,
            })}
            style={{
              width: "85%",
            }}
          >
            <div
              className="d-flex justify-content-center"
              onClick={() => handleSetActiveTool("allTools")}
            >
              <h2>{open ? "AI Models" : "AI"}</h2>
            </div>
            <DropdownMenuDivider />
            <span className="text-xs mt-2 ml-2 text-uppercase font-weight-bold text-lighter">
              Brie Private AI
            </span>
            {brieAITools.map((AITool) => {
              return (
                <div
                  key={AITool.key}
                  className={classNames(
                    "d-flex link-hovered-no-radius align-items-center cursor-pointer",
                    {
                      "sidebar-link-active-no-radius": tab === AITool.key,
                      "p-2": open,
                      "justify-content-center": !open,
                    }
                  )}
                  style={{
                    border: "1px solid transparent",
                    fontSize: "15px",
                    fontWeight: 500,
                    height: "62px",
                  }}
                  onClick={() => handleSetActiveTool(AITool.key)}
                >
                  <i className={AITool.icon} style={{ fontSize: "24px" }}></i>
                  {open && <div className="pl-2 mb-0">{AITool.title}</div>}
                </div>
              );
            })}
            <span className="text-xs mt-3 ml-2 text-uppercase font-weight-bold text-lighter">
              Open AI
            </span>
            {openAITools.map((AITool) => {
              return (
                <div
                  key={AITool.key}
                  className={classNames(
                    "d-flex link-hovered-no-radius align-items-center cursor-pointer",
                    {
                      "sidebar-link-active-no-radius": tab === AITool.key,
                      "p-2": open,
                      "justify-content-center": !open,
                    }
                  )}
                  style={{
                    border: "1px solid transparent",
                    fontSize: "15px",
                    fontWeight: 500,
                    height: "62px",
                  }}
                  onClick={() => handleSetActiveTool(AITool.key)}
                >
                  <i className={AITool.icon} style={{ fontSize: "24px" }}></i>
                  {open && <div className="pl-2 mb-0">{AITool.title}</div>}
                </div>
              );
            })}
          </Card>
        </div>
      )}
    </>
  );
};

export default BrieMobileSidebar;
